 function loadBadge (){
       var badgeImage = document.getElementById('image-badge');
           
              var modalOpener = document.querySelector('modal-opener');
  
              if (badgeImage && modalOpener) {
              
                badgeImage.style.display = 'block';
                badgeImage.style.position = 'absolute';
                badgeImage.style.top = '10px';
                badgeImage.style.right = '10px';
                modalOpener.style.position = 'relative';
                modalOpener.appendChild(badgeImage);
              }

             
   
     }
          document.addEventListener('DOMContentLoaded', function() {
            loadBadge();
          });